module.exports = __webpack_public_path__ + "static/media/zr_2_8.8d4efc7d.png";